// extracted by mini-css-extract-plugin
export default {"multicolor-bar":"multicolor-bar_multicolor-bar__IK0dR"};